var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:_vm.btCss,attrs:{"to":{ path: _vm.btUrl },"id":_vm.btId}},[_vm._v(" "+_vm._s(_vm.btText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }